var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isRegStepper && _vm.canSeeBilling)?_c('BillingBalanceContainer',{staticClass:"cabinet__withdrawal pt-8",on:{"update:withdraw":_vm.openWithdraw}}):_vm._e(),(!_vm.isRegStepper && _vm.canSeeRating)?_c('Rating',{class:{ 'mt-8': _vm.canSeeBilling }}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }